import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { AppState } from '../../../types/store';
import { updateFolderOrder } from '../../../actions/studio/folders';
import { Props } from './FolderListDesktop';
import { getFeaturedFolderId } from '../../../selectors/studio';

export type StateProps = Pick<Props, 'featuredFolderId'>;
export type DispatchProps = Pick<Props, 'updateFolderOrder'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  featuredFolderId: getFeaturedFolderId(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = dispatch => ({
  updateFolderOrder: (folder, position) => dispatch(updateFolderOrder(folder, position)),
});

export default connect(mapStateToProps, mapDispatchToProps);
